export default {
  // 获取问卷详情
  getQuestionnaireDetail: '/member/anonymous/amc/getQuestionnaireDetail',
  // 获取问卷详情 H5
  getQuestionnaireDetailForH5: '/member/anonymous/amc/getQuestionnaireDetailForH5',
  // 获取多主体
  getMainbodyList: '/member/anonymous/amc/getMainbodyList',
  // 获取调查问卷需要显示的自定义字段
  getCustomMemberFields: '/member/anonymous/amc/getCustomMemberFields',
  // 获取问卷题目
  getQuestionnaireSubjects: '/member/anonymous/amc/getQuestionnaireSubjects',
  // 保存答卷
  addQuestionAnswer: '/member/anonymous/amc/addQuestionAnswer'
}